/**
 * Unique identifier for the current chat conversation session.
 * Generated once per page load and used for both server logging and Matomo tracking.
 * Format: YYYY-MM-DD_randomstring
 */
export const conversationId = `${new Date().toISOString().slice(0, 10)}_${Math.random().toString(36).substring(2, 10)}`;
